module.exports = __webpack_public_path__ + "img/player_damage_004.95818452.png";